import { useEffect } from 'react'
import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'
import BottomSheetContent from './BottomSheetContent'
import { HelpDialogPassage } from './HelpDialogPassage'

type BottomSheetWrapperPropTypes = {
  onDismiss: () => void
  ScreenName: string
}

const TITLE_CLASS = 'text-[#232323] text-sm font-medium leading-[21px]'
const BODY_CLASS = 'text-[#6a6e6e] text-sm font-normal leading-[21px]'

const PASSAGES = [
  {
    title: 'AUM',
    body: 'AUM or Assets Under Management is the total market value of investments that a mutual fund manages on behalf of its investors.'
  },
  {
    title: 'AUM change',
    body: "AUM change is the increase or decrease in a fund's AUM due to reasons like fluctuations in value of underlying assets, or inflow/outflow of investments."
  }
] as const

export const FundHoldingsBottomSheet = ({ onDismiss, ScreenName }: BottomSheetWrapperPropTypes) => {
  const heading = 'Fund Holdings'
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent heading={heading} onDismiss={onDismiss}>
      <div className='flex flex-col gap-4'>
        {PASSAGES.map((passage) => (
          <HelpDialogPassage
            key={passage.title}
            accessibleLabel={`${passage.title}. ${passage.body}`}
          >
            <span className={TITLE_CLASS}>{passage.title}</span>
            <br />
            <span className={BODY_CLASS}>{passage.body}</span>
          </HelpDialogPassage>
        ))}
      </div>
    </BottomSheetContent>
  )
}
